var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('advanced-table',{attrs:{"headers":_vm.headers,"filters":_vm.filters,"sortBy":['dueDate'],"sortDesc":[true],"resource":_vm.resource,"optionLists":_vm.optionLists}})}
var staticRenderFns = []

export { render, staticRenderFns }